import { Api } from '~/App/utils/api'
import { API_URL } from '~/constants/environment'

import type { SurveyQuestionsResponse, SurveyResponse } from '../@types'

const api = new Api(API_URL, 'customers')

export const fetchSurveyQuestions = async () => {
  return (await api.get<{ data: SurveyQuestionsResponse }>({ path: 'survey_questions' })).data
}

export const saveSurvey = async (data: SurveyResponse[]) => {
  return api.post({ path: 'surveys', body: { data } })
}
